import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ScrollAffordanceState } from '../../../utilities/scroll-affordance';

@Component({
  selector: 'app-sidebar-scroll-affordance',
  imports: [FaIconComponent],
  templateUrl: './sidebar-scroll-affordance.component.html',
  styleUrl: './sidebar-scroll-affordance.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarScrollAffordanceComponent {
  readonly state = input.required<ScrollAffordanceState>();
  readonly pageDown = output<void>();
  readonly bobbing = signal(false);

  constructor() {
    effect(() => {
      const state = this.state();
      if (state.playBob) {
        this.bobbing.set(true);
      }
      if (!state.showBottomHint) {
        this.bobbing.set(false);
      }
    });
  }

  onBobAnimationEnd(): void {
    this.bobbing.set(false);
  }
}
